import React, { memo, useEffect, useState } from 'react';
import { isEmpty, has } from 'lodash';

import AutoComplete from 'components/ui/AutoComplete';
import { getOrganizations } from 'api/organization';

const Client = memo(
  ({
    organization,
    setFieldValue,
    organizationId,
    subLocationId,
    sublocation,
    sublocationOptions,
    errors,
    touched,
  }) => {
    const [organizations, setOrganizations] = useState([]);

    useEffect(async () => {
      const { data: orgData } = await getOrganizations(0, 10000);

      setOrganizations(orgData.data);
    }, []);

    if (isEmpty(organizations)) {
      return null;
    }

    return (
      <>
        <AutoComplete
          data={organizations}
          label="Organization"
          name="organizationId"
          setFieldValue={setFieldValue}
          value={organizationId}
          groupBy="name"
          getOptionLabel={({ name }) => name || ''}
          selection={organization}
          required
          error={touched.organizationId && has(errors, 'organizationId')}
          touched={touched}
          bottom="-1"
        />

        <AutoComplete
          data={sublocationOptions}
          label="Sub Location"
          name="subLocationId"
          setFieldValue={setFieldValue}
          value={subLocationId}
          groupBy="formatted_name"
          getOptionLabel={({ formatted_name: formattedName }) => formattedName}
          selection={sublocation}
          error={touched.subLocationId && has(errors, 'subLocationId')}
          required
          touched={touched}
          subLocation
          orgId={organizationId}
          className={!organizationId && 'hidden'}
        />
      </>
    );
  },
);

export default Client;
